import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateUserResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const associateUser = {
    record(data: typeof Requests.AssociateUser.Record.Input) {
        return post<typeof data, AssociateUserResponseTypes.Record>(`/associate-user/record`, data);
    },
    create(data: typeof Requests.AssociateUser.Create.Input) {
        return post<typeof data>(`/associate-user/create`, data);
    },
    obtain(id: string) {
        return get<AssociateUserResponseTypes.Obtain>(`/associate-user/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<AssociateUserResponseTypes.Select>(
                `/associate-user/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        selectMarketing: (async (param?: SelectParam) => {
            const req = get<AssociateUserResponseTypes.SelectMarketing>(
                `/associate-user/select-marketing` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateUser.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-user/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
    dev: {
        masquerade(id: string) {
            return get<AssociateUserResponseTypes.Masquerade>(
                `/dev/associate-user/masquerade/${id}`,
            );
        },
    },
};
